export const reasonKeyByBlockReason = {
  TrialExpired: 'trialExpired',
  SubscriptionCanceled: 'subscriptionCanceled',
  SubscriptionExpired: 'subscriptionExpired',
  SubscriptionSuspended: 'subscriptionSuspended',
  PaymentMethodRequired: 'paymentMethodRequired',
  SubscriptionPastDue: 'subscriptionPastDue',
  ExtraStoreDeactivated: 'extraStoreDeactivated',
};

export const checkoutBlockReasons = new Set([
  'TrialExpired',
  'SubscriptionCanceled',
  'SubscriptionExpired',
  'PaymentMethodRequired',
  'SubscriptionPastDue',
  'ExtraStoreDeactivated',
]);

export const getStoreAccessReasonKey = (blockReason) => (
  reasonKeyByBlockReason[blockReason] || 'subscriptionExpired'
);
